import { render, staticRenderFns } from "./ProductStats.vue?vue&type=template&id=65e1aa77&scoped=true&"
import script from "./ProductStats.vue?vue&type=script&lang=js&"
export * from "./ProductStats.vue?vue&type=script&lang=js&"
import style0 from "./ProductStats.vue?vue&type=style&index=0&id=65e1aa77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1aa77",
  null
  
)

export default component.exports